import { Form, Select, TreeSelect } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import SelectProjectComponent from '../../../../../../../../components/SelectProjectComponent/SelectProjectComponent';
import { FolderDataNode } from '../../../../../../../../model/elements';
import { Connection, Project } from '../../../../../../../../model/entities';

const EditableCell: React.FC<Props> = ({
    editing,
    connection,
    identifier,
    dataIndex,
    title,
    index,
    children,
    folderNodes,
    onProjectChange,
    onFolderChange,
    onGetProject,
    onListProjects,
    ...restProps
}) => {
    return (
        <td {...restProps}>
            {editing
                ? getFormItem(
                      identifier,
                      connection,
                      dataIndex,
                      folderNodes,
                      onProjectChange,
                      onFolderChange,
                      onGetProject,
                      onListProjects,
                  )
                : children}
        </td>
    );
};
export default EditableCell;

const getFormItem = (
    identifier: string,
    connection: Connection,
    dataIndex: any,
    folderNodes: FolderDataNode[],
    onProjectChange: (projectId: string) => Promise<void>,
    onFolderChange: (folderId: string) => Promise<void>,
    onGetProject: (projectId: string) => Promise<Project | undefined>,
    onListProjects: (searchText: string) => Promise<Project[]>,
) => {
    switch (identifier) {
        case 'project':
            return (
                <Form.Item name={dataIndex} style={{ margin: 0 }}>
                    <SelectProjectComponent
                        showSearch
                        onChange={connection.target?.provider === 'ACONEX' ? () => {} : (value) => onProjectChange(value as string)}
                        onGet={onGetProject}
                        onList={onListProjects}
                    />
                </Form.Item>
            );
        case 'folder':
            return connection.target?.provider === 'ACONEX' ? (
                <Form.Item name={dataIndex} style={{ margin: 0 }}>
                    <Select>{folderOptions()}</Select>
                </Form.Item>
            ) : (
                <Form.Item name={dataIndex} style={{ margin: 0 }}>
                    <TreeSelect
                        style={{ width: '100%' }}
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        treeData={folderNodes}
                        loadData={(folderNode) => onFolderChange(folderNode.folder.id)}
                    />
                </Form.Item>
            );

        default:
            break;
    }
};

const folderOptions = () => (
    <Select.Option key="temporaryFiles" value="temporaryFiles">
        <FormattedMessage id="connectionLink.targets.temporaryFiles" />
    </Select.Option>
);
interface Props extends React.HTMLAttributes<HTMLElement> {
    connection: Connection;
    editing: boolean;
    identifier: string;
    dataIndex: string;
    title: any;
    index: number;
    children: React.ReactNode;
    folderNodes: FolderDataNode[];
    onProjectChange: (projectId: string) => Promise<void>;
    onFolderChange: (folderId: string) => Promise<void>;
    onGetProject: (projectId: string) => Promise<Project | undefined>;
    onListProjects: (searchText: string) => Promise<Project[]>;
}
